import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { GlobalComponent } from 'src/app/global/global.component';
import { AddTypeBO,AddNoteBO,GetListBasenote,GetListBasetype} from './client-notes.modal';
@Injectable({
  providedIn: 'root'
})
export class ClientNotesDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  // public executetype(ATState: GetListBasetype): void {
  //   this.gettype(ATState).subscribe(x => super.next(x));
  // }
  // gettype(ATState?: GetListBasetype): Observable<DataStateChangeEventArgs> {
  //   return this.http.post<any>("api/NoteType/GetNoteType?", ATState)
  //     .pipe(map(
  //       (response: any) =>
  //         <any>{
  //           result: response['result'],
  //           count: response['count']
  //         }
  //     ))


  // }

  public executenotes(ANState: GetListBasenote): void {
    this.getnotes(ANState).subscribe(x => super.next(x));
  }
  getnotes(ANState: GetListBasenote): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientNote/GetCliNotebyFilter", ANState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))


  }


}